import React from 'react';
import styled from '@emotion/styled';

import PointTitle01Img from 'ui/images/top_for_buyer/point_title_01.svg';
import PointTitle02Img from 'ui/images/top_for_buyer/point_title_02.svg';
import PointTitle03Img from 'ui/images/top_for_buyer/point_title_03.svg';

import BgPointSection01PcImg from 'ui/images/top_for_buyer/bg_point_section_01_pc.svg';
import BgPointSection02PcImg from 'ui/images/top_for_buyer/bg_point_section_02_pc.svg';

import AboutManyPcImg from 'ui/images/top_for_buyer/about_many_pc.svg';
import AboutManySpImg from 'ui/images/top_for_buyer/about_many_sp.svg';
import PointTitlePcImg from 'ui/images/top_for_buyer/point_title_pc.svg';
import PointTitleSpImg from 'ui/images/top_for_buyer/point_title_sp.svg';
import AboutManyTopImg from 'ui/images/top/about_many_top.svg';
import AboutMany1Img from 'ui/images/top/about_many_4.png';
import AboutMany2Img from 'ui/images/top/about_many_5.png';
import AboutMany3Img from 'ui/images/top/about_many_6.png';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--white);
    gap: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${mqMin('NARROW')} {
        gap: 8rem;
    }
`;

const SectionTop = styled.div`
    line-height: 1.8em;
    padding: 5rem 0;
    margin-bottom: -8rem;
`;

const Sections = styled.div`
    display: flex;
    flex-direction: column;
    background-color: var(--light-orange);

    ${mqMin('NARROW')} {
        min-height: 700px;
        background-image: url(${BgPointSection01PcImg}), url(${BgPointSection02PcImg});
        background-position: top 2rem center, bottom 3rem center;
        background-repeat: no-repeat, no-repeat;
        background-size: 100%, 100%;
        padding-bottom: 2rem;
    }

    ${mqMin('WIDE')} {
        background-position: top -10rem center, bottom -25rem center;
    }
`;

const Section = styled.div`
    line-height: 1.8em;
    width: 100%;
    margin: 0 auto;
    position: relative;
    align-items: center;
    justify-content: center;

    ${mqMin('NARROW')} {
        min-height: 26rem;
        max-width: 1512px;
        display: flex;
    }
`;

const TitleSection = styled.div`
    line-height: 1.8em;
    width: 100%;
    margin: 0 auto;
    position: relative;
    padding: 3rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${mqMin('NARROW')} {
        padding: 4rem 0;
    }
`;

const PointTitle = styled.div`
    width: 18.9rem;
    height: auto;

    ${mqMin('NARROW')} {
        width: 37.1rem;
    }
`;

const AboutManyPcTitle = styled.img`
    display: none;
    width: 16.5rem;
    margin: 0 auto 3rem;

    ${mqMin('NARROW')} {
        display: block;
    }
`;

const AboutManySpTitle = styled.img`
    display: block;
    width: 15rem;
    margin: 0 auto 4rem auto;

    ${mqMin('SP')} {
        margin: 0 auto 2.5rem auto;
    }

    ${mqMin('NARROW')} {
        display: none;
    }
`;

const DarkBlueText = styled.div`
    color: var(--dark-blue);
    font-size: 1.5rem;
    line-height: 2.724rem;
    gap: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    padding: 0 0.7rem;
    position: relative;

    ${mqMin('NARROW')} {
        line-height: 3.3rem;
        flex-direction: row;
        font-size: 1.6rem;
        text-align: left;
    }
`;

const DarkBlueSmallText = styled.div`
    color: var(--dark-blue);
    font-size: 0.888rem;
    line-height: 1.8rem;
    width: 100%;
    text-align: left;

    ${mqMin('SP')} {
        text-align: center;
    }

    ${mqMin('NARROW')} {
        text-align: left;
    }

    span {
        text-decoration: underline;
        text-decoration-color: var(--dark-blue);
    }
`;

const Strong = styled.strong`
    position: relative;
    color: var(--primary);
    font-size: 1.778rem;
    margin-bottom: 2rem;

    ${mqMin('NARROW')} {
        margin: 0;
    }
`;

const StrongWithAfter = styled(Strong)`
    &::after {
        position: absolute;
        left: 50%;
        content: '・';
        transform: translateX(-50%);
        top: -1.8rem;
        font-size: 1.8rem;

        ${mqMin('NARROW')} {
            top: -2rem;
        }
    }
    font-size: 1.987rem;

    ${mqMin('NARROW')} {
        font-size: 2rem;
    }
`;

const AboutManyTopImgItem = styled.img`
    width: 18.8rem;
    height: auto;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        width: 25rem;
    }
`;

const AboutMany1ImgItem = styled.img`
    width: 22rem;
    top: 14.6rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    border: 7px solid #000;

    ${mqMin('NARROW')} {
        width: 34.5rem;
        margin: 0;
        transform: translateX(0);
        left: 37rem;
        top: 2.7rem;
    }
`;
const Point1Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    padding: 3rem 1.5rem 8.5rem;
    text-align: center;

    ${mqMin('NARROW')} {
        width: 27.5rem;
        padding: 2.5rem 4rem;
        gap: 1.5rem;
        border-radius: 8px;
        text-align: left;
        position: absolute;
        justify-content: center;
        top: 0;
        left: 12rem;
    }
`;

const Point2Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    padding: 3rem 1.5rem 8.5rem;
    text-align: center;

    ${mqMin('NARROW')} {
        width: 29.2rem;
        padding: 2.1rem 2rem 2.5rem 6rem;
        gap: 1.5rem;
        justify-content: center;
        border-radius: 8px;
        text-align: left;
        position: absolute;
        left: 42rem;
        top: 2.7rem;
    }
`;

const AboutMany2ImgItem = styled.img`
    width: 22rem;
    top: 18rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    border: 7px solid #000;

    ${mqMin('SP')} {
        top: 16rem;
    }

    ${mqMin('NARROW')} {
        top: 0;
        left: 12rem;
        width: 34.5rem;
        transform: translateX(0);
    }
`;

const AboutMany3ImgItem = styled.img`
    width: 22rem;
    top: 18rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    border: 7px solid #000;

    ${mqMin('SP')} {
        top: 16rem;
    }

    ${mqMin('NARROW')} {
        left: 37rem;
        top: 2.7rem;
        width: 34.5rem;
        transform: translateX(0);
    }
`;

const Point3Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    padding: 3rem 1.5rem 8.5rem;
    text-align: center;

    ${mqMin('NARROW')} {
        width: 28rem;
        padding: 2.1rem 2rem 2.5rem 3rem;
        gap: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 8px;
        text-align: left;
        position: absolute;
        top: 0;
        left: 12rem;
    }
`;

const PointItemTitle = styled.div`
    width: 8.4rem;
    margin: 0 auto 1.3rem;

    ${mqMin('NARROW')} {
        width: 9rem;
        margin: 0;
    }

    img {
        width: 100%;
        height: auto;
    }
`;

const BgOrange = styled.div`
    background-color: var(--light-orange);
    width: 100%;
    height: 10rem;
`;

export const SubTitleSection: React.FC = () => {
    return (
        <Container id="about-many">
            <SectionTop className="fadein fadein_y">
                <AboutManyPcTitle src={AboutManyPcImg} alt="MAnyとは" />
                <AboutManySpTitle src={AboutManySpImg} alt="MAnyとは" />

                <DarkBlueText>
                    <div>
                        <StrongWithAfter>完</StrongWithAfter>
                        <StrongWithAfter>全</StrongWithAfter>
                        <StrongWithAfter>無</StrongWithAfter>
                        <StrongWithAfter>料</StrongWithAfter>
                        で、
                        <Only sp>
                            <br />
                        </Only>
                        希望の売り案件を
                        <Only pc>
                            <br />
                        </Only>
                        持っている
                        <Only sp>
                            <br />
                        </Only>
                        仲介会社を
                        <Only pc>
                            <br />
                        </Only>
                        選択するための
                        <Only sp>
                            <br />
                        </Only>
                        <Strong>比較検討</Strong>ができます。 <br />
                        <Only sp>
                            <AboutManyTopImgItem src={AboutManyTopImg} alt="イラスト" />
                        </Only>
                        <DarkBlueSmallText>
                            Ｍ＆Ａ仲介会社から持ち込まれた案件から探すだけではなく、
                            <Only pc>
                                <br />
                            </Only>
                            あなたの希望にマッチする案件を持った仲介会社を探すことができます。
                        </DarkBlueSmallText>
                    </div>
                    <Only pc>
                        <AboutManyTopImgItem src={AboutManyTopImg} alt="イラスト" />
                    </Only>
                </DarkBlueText>
            </SectionTop>
            <Sections>
                <TitleSection className="fadein fadein_y">
                    <PointTitle>
                        <Only pc>
                            <img src={PointTitlePcImg} alt="買い手企業版MAnyの3つのポイント" />
                        </Only>
                        <Only sp>
                            <img src={PointTitleSpImg} alt="買い手企業版MAnyの3つのポイント" />
                        </Only>
                    </PointTitle>
                </TitleSection>
                <Section className="fadein fadein_y">
                    <Only pc>
                        <Point1Container>
                            <PointItemTitle>
                                <img src={PointTitle01Img} alt="ポイント1" />
                            </PointItemTitle>
                            <Strong>最大5社と面談可能</Strong>
                            <DarkBlueSmallText>
                                希望条件を匿名投稿すると、
                                <br />
                                貴社へ提案を希望する仲介会社から
                                <br />
                                オファーが届きます
                            </DarkBlueSmallText>
                        </Point1Container>
                        <AboutMany1ImgItem src={AboutMany1Img} alt="イラスト" />
                    </Only>
                    <Only sp>
                        <Point1Container>
                            <PointItemTitle>
                                <img src={PointTitle01Img} alt="ポイント1" />
                            </PointItemTitle>
                            <Strong>最大5社と面談可能</Strong>
                            <DarkBlueSmallText>
                                希望条件を匿名投稿すると、貴社へ提案を希望する仲介会社から オファーが届きます
                            </DarkBlueSmallText>
                            <AboutMany1ImgItem src={AboutMany1Img} alt="イラスト" />
                        </Point1Container>
                        <BgOrange />
                    </Only>
                </Section>
                <Section className="fadein fadein_y">
                    <Only pc>
                        <Point2Container>
                            <PointItemTitle>
                                <img src={PointTitle02Img} alt="ポイント2" />
                            </PointItemTitle>
                            <Strong>スピーディーな案件探し</Strong>
                            <DarkBlueSmallText>
                                売り手企業は、原則専任契約となっています。
                                <br />
                                どの仲介会社が希望の案件を持っているかを
                                <br />
                                探す時間が大幅に削減されます
                            </DarkBlueSmallText>
                        </Point2Container>
                        <AboutMany2ImgItem src={AboutMany2Img} alt="イラスト" />
                    </Only>
                    <Only sp>
                        <Point2Container>
                            <PointItemTitle>
                                <img src={PointTitle02Img} alt="ポイント2" />
                            </PointItemTitle>
                            <Strong>スピーディーな案件探し</Strong>
                            <AboutMany2ImgItem src={AboutMany2Img} alt="イラスト" />
                            <DarkBlueSmallText>
                                売り手企業は、原則専任契約となっています。どの仲介会社が希望の案件を持っているかを探す時間が大幅に削減されます
                            </DarkBlueSmallText>
                        </Point2Container>
                        <BgOrange />
                    </Only>
                </Section>
                <Section className="fadein fadein_y">
                    <Only pc>
                        <Point3Container>
                            <PointItemTitle>
                                <img src={PointTitle03Img} alt="ポイント3" />
                            </PointItemTitle>
                            <Strong>手数料などの比較が簡単</Strong>
                            <DarkBlueSmallText>
                                複数社と同時にやり取りを <br />
                                進めることができるため、 <br />
                                手数料などの投資コストも同時に <br />
                                比較検討が可能です
                            </DarkBlueSmallText>
                        </Point3Container>
                        <AboutMany3ImgItem src={AboutMany3Img} alt="イラスト" />
                    </Only>
                    <Only sp>
                        <Point3Container>
                            <PointItemTitle>
                                <img src={PointTitle03Img} alt="ポイント3" />
                            </PointItemTitle>
                            <Strong>手数料などの比較が簡単</Strong>
                            <AboutMany3ImgItem src={AboutMany3Img} alt="イラスト" />
                            <DarkBlueSmallText>
                                複数社と同時にやる取りを進めることができるため、手数料などの投資コストも同時に比較検討が可能です
                            </DarkBlueSmallText>
                        </Point3Container>
                        <BgOrange />
                    </Only>
                </Section>
            </Sections>
        </Container>
    );
};
